<template>
  <div id="no-result">
    <div class="content-no-result">
      <div class="title">ยังไม่มี{{nameThaiTab}}ที่คุณติดตาม</div>
    </div>
    <router-link class="button-no-result" :to="generateLink" data-action="search_asset">
      <span v-if="type === 'gold'">ดูราคาทองทั้งหมด</span>
      <span v-else>
        <i class="fas fa-search"></i>
        ค้นหา{{nameThaiTab}}
      </span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {}
  },
  props: ['nameThaiTab', 'type'],
  computed: {
    generateLink() {
      if (this.type === 'gold')
        return {
          name: 'miniapp-market-gold',
          query: { activeMenu: 'miniapp-market-gold' }
        }
      return { name: 'miniapp-search', query: { toggleSearch: true } }
    }
  }
}
</script>

<style lang="scss" scoped>
#no-result {
  @extend %container-style;
  margin-top: 96px;
  text-align: center;
  .content-no-result {
    margin: 18px 0;
    .title {
      @extend %font-size-l;
      font-weight: bold;
      color: $color-light-grey-2;
    }
  }
  .button-no-result {
    @include finRippleBtn(#f9f9f9, #f9f9f9, $color-normal-text);
    @extend %font-size-ss;
    padding: 11px 25px;
    text-decoration: none;
    font-weight: bold;
    border-radius: 4px;
    display: inline-block;
    i {
      pointer-events: none;
      margin-right: 10px;
    }
  }
}
</style>